export default "__VITE_ASSET__DORPChLO__"